export default "__VITE_ASSET__DfZR9xur__"